import Vue from 'vue'
import Router from 'vue-router'

import homeRoutes from './home'
import errorRoutes from './error'
// import clgkRoutes from './clgk'
// import xwzxRoutes from './xwzx'
// import zwxxRoutes from './zwxx'
// import zcfgRoutes from './zcfg'
// import hdjlRoutes from './hdjl'
// import bsfwRoutes from './bsfw'
// import ztzlRoutes from './ztzl'
// import xxhRoutes from './xxh'
// import zzjsRoutes from './zzjs'
// import jyjyRoutes from './jyjy'
// import kfRoutes from './kf'
// import fzqjRoutes from './fzqj'
// import xcwtRoutes from './xcwt'
// import jgdwRoutes from './jgdw'
// import wqRoutes from './wq'
// import zsdwRoutes from './zsdw'
// import cjrzcRoutes from './cjrzc'
// import sclzmxhRoutes from './sclzmxh'
// import sprdRoutes from './sprd'
// import sgypsRoutes from './sgyps'
import newClassRoutes from './newsClass'
import newsRoutes from './news'
import searchRoutes from './search'

Vue.use(Router)
const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const children = [...homeRoutes, ...newClassRoutes, ...newsRoutes, ...searchRoutes]

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/wza',
      name: 'wza',
      component: resolve => require(['@/views/wzaMain.vue'], resolve),
      children: [
        {
          path: '/wza',
          name: 'WzaHome',
          component: resolve => require(['@/views/home'], resolve),
        },
        {
          path: '/wza/content',
          component: resolve => require(['@/views/page'], resolve),
          name: 'wzaContent',
        },
        {
          path: '/wza/contentForm',
          component: resolve => require(['@/views/contentForm'],resolve),
          name: 'wzaContentForm',
        },
        {
          path: '/wza/list',
          component: resolve => require(['@/views/list'], resolve),
          name: 'wzaList',
        },
        {
          path: '/wza/form1',
          component: resolve => require(['@/views/form1'], resolve),
          name: 'wzaForm1',
        },
        {
          path: '/wza/formAndList',
          component: resolve => require(['@/views/formAndList'], resolve),
          name: 'wzaFormAndList',
        },
        {
          path: '/wza/childClass',
          component: resolve => require(['@/views/childClass'], resolve),
          name: 'wzaChildClass'
        },
        {
          path: '/wza/page',
          component: resolve => require(['@/views/page'], resolve),
          name: 'wzaPage',
        }
      ]
    },
    {
      path: '/',
      name: '',
      component: resolve => require(['@/views/Main.vue'], resolve),
      children
    },
    {
      path: '/sgyp',
      name: 'sgyp',
      component: resolve => require(['@/views/sgyp/index.vue'], resolve),
      children
    },
    ...errorRoutes
  ]
})

router.beforeEach((to, from, next) => {
  window.scroll(0, 0);
  next();
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js